import "reflect-metadata";
import { IsDate, IsString, IsUUID, IsOptional } from "class-validator";

export default class TestingCommentFile {
  @IsUUID("4")
  public readonly id?: string;

  @IsUUID("4")
  public comment_id?: string;

  @IsString()
  public url?: string;

  @IsOptional()
  @IsDate()
  public created_at?: Date;

  public constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.comment_id = data.comment_id;
      this.url = data.url || this.url;
      this.created_at = data.created_at || this.created_at;
    }
  }
}
